import {
    Component,
    Input,
    OnInit,
    ViewContainerRef,
    ComponentFactoryResolver
} from '@angular/core';

import { ToolbarComponent } from '../../toolbar/toolbar.component';

@Component({
    selector: 'toolbar-dynamic',
    templateUrl: './toolbar-dynamic.component.html',
    styleUrls: ['./toolbar-dynamic.component.scss']
})

export class ToolbarComponentDynamic implements OnInit {
    @Input() public RefToolbarComponent: any;

    constructor(private vcr: ViewContainerRef, private cfr: ComponentFactoryResolver) {

    }

    ngOnInit() {
        if (this.RefToolbarComponent) {
            this.vcr.createComponent(this.RefToolbarComponent);
        } else {
            let myComp = this.cfr.resolveComponentFactory(ToolbarComponent);
            this.vcr.clear();
            this.vcr.createComponent(myComp);
        }
    }
}
